<template>
  <div class="container is-fluid">
    <h3 class="title is-3">Neuer Nutzer</h3>
    <div class="field">
        <label class="label">Nutzername</label>
        <div class="control is-expanded">
            <input class="input" type="text" v-model="username" v-on:keyup.enter="addUser" placeholder="Nutzername" />
        </div>
    </div>
    <div class="field">
        <label class="label">Passwort</label>
        <div class="control is-expanded">
            <input class="input" type="password" v-model="password" v-on:keyup.enter="addUser" placeholder="Passwort" />
        </div>
    </div>
    <div class="field">
      <label class="label">Passwort wiederholen</label>
        <div class="control is-expanded">
            <input v-bind:class="{input: true, 'is-danger': password != repeatPassword}" type="password" v-model="repeatPassword" 
            v-on:keyup.enter="addUser" placeholder="Passwort wiederholen" />
        </div>
    </div>
    <div class="notification is-success" v-if="message.length > 0">
        {{message}}
    </div>
    <div class="notification is-danger" v-if="errorMessage.length > 0">
        {{errorMessage}}
    </div>
    <div class="is-pulled-right">
        <button class="button" v-on:click="addUser">Hinzufügen</button>
    </div>
  </div>
</template>

<script>
  import rpc from '../rpc.js';
  export default {
    data() {
      return {
        username: "",
        password: "",
        repeatPassword: "",
        message: "",
        errorMessage: ""
      }
    },
    components: {
      
    },
    methods: {
      addUser() {
          this.message = "";
          this.errorMessage = "";
          if(this.password != this.repeatPassword) {
              return;
          }
          let user = {name: this.username, password: this.password, groups: []};
          rpc.request("LoginService.Register", user).then(resp => {
              if(resp.status == 201) {
                this.message = `Nutzer "${this.username}" erstellt!`;
                this.username = "";
                this.password = "";
                this.repeatPassword = "";
              } else {
                  console.log(resp)
                  this.errorMessage = resp.errorMessage;
              }
          }).catch(err => {
              this.errorMessage = "error creating user. See log for details";
              console.log(err);
          })
      }
    }
  }
</script>